import { TagStatuses } from '@crm/utils'
import { Form, Radio, Tag } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const RadioElement = ({ element, required }: Props) => {
  return (
    <Form.Item
      name={element.name}
      label={element.label}
      rules={[{ required }]}
      initialValue={null}
    >
      <Radio.Group
        name="radiogroup"
        options={(element?.props?.options || [])?.map((option: string[]) => ({
          label: (
            <Tag color={TagStatuses[option[2] as keyof typeof TagStatuses]}>
              {option[1]}
            </Tag>
          ),
          value: option[0]
        }))}
      />
    </Form.Item>
  )
}
